import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function DiceRollerCalc() {
  const [count, setCount] = useState(2);
  const [sides, setSides] = useState(6);
  const [rolls, setRolls] = useState([]);
  const [mode, setMode] = useState('conv');
  const [rolling, setRolling] = useState(false);
  const [rollKey, setRollKey] = useState(0);

  const roll = () => {
    const n = Math.max(1, Math.min(50, Number(count)));
    const s = Math.max(2, Math.min(1000, Number(sides)));
    setRolling(true);
    setRollKey(k => k + 1);
    // Animate ~800ms — flash random values, then settle on final
    const interval = setInterval(() => {
      setRolls(Array.from({ length: n }, () => Math.floor(Math.random() * s) + 1));
    }, 80);
    setTimeout(() => {
      clearInterval(interval);
      const out = Array.from({ length: n }, () => Math.floor(Math.random() * s) + 1);
      setRolls(out);
      setRolling(false);
    }, 800);
  };

  const total = rolls.reduce((a, b) => a + b, 0);

  const pip = (v) => {
    const positions = {
      1: [[50,50]], 2:[[30,30],[70,70]], 3:[[30,30],[50,50],[70,70]],
      4:[[30,30],[30,70],[70,30],[70,70]], 5:[[30,30],[30,70],[50,50],[70,30],[70,70]],
      6:[[30,25],[30,50],[30,75],[70,25],[70,50],[70,75]]
    };
    return (
      <svg viewBox="0 0 100 100" className="w-16 h-16">
        <rect x="4" y="4" width="92" height="92" rx="14" fill="#fff" stroke="#0f172a" strokeWidth="3" />
        {(positions[v] || []).map(([x,y], i) => <circle key={i} cx={x} cy={y} r="9" fill="#0f172a" />)}
      </svg>
    );
  };

  return (
    <CalcShell look="cnet" title="Dice Roller" subtitle="Roll standard or custom N-sided dice with realistic tumble animation.">
      <style>{`
        @keyframes diceTumble {
          0%   { transform: translateY(-40px) rotate(0deg) scale(0.6); opacity: 0; }
          30%  { transform: translateY(0)      rotate(360deg) scale(1.1); opacity: 1; }
          60%  { transform: translateY(-14px)  rotate(600deg) scale(1);   }
          80%  { transform: translateY(0)      rotate(720deg) scale(1);   }
          100% { transform: translateY(0)      rotate(720deg) scale(1);   }
        }
        .dice-tumble { animation: diceTumble 800ms cubic-bezier(0.34, 1.56, 0.64, 1); transform-origin: center; }
        @keyframes diceShake {
          0%,100% { transform: rotate(0deg); }
          25%     { transform: rotate(-8deg); }
          50%     { transform: rotate(8deg); }
          75%     { transform: rotate(-4deg); }
        }
        .dice-rolling { animation: diceShake 80ms infinite; }
      `}</style>
      <div className="flex gap-2 border-b mb-4">
        {[['conv','Conventional Dice'],['custom','Custom Sides']].map(([v,l]) => (
          <button key={v} className={`px-4 py-2 text-sm font-semibold ${mode===v?'border-b-2 border-blue-600 text-blue-700':'text-slate-500'}`} onClick={() => { setMode(v); setSides(v==='conv'?6:20); }}>{l}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Number of Dice</label>
            <input type="number" min={1} max={50} value={count} onChange={e => setCount(e.target.value)} data-testid="dice-count" />
          </div>
          {mode === 'custom' && (
            <div className="field"><label>Sides per die</label>
              <input type="number" min={2} max={1000} value={sides} onChange={e => setSides(e.target.value)} data-testid="dice-sides" />
            </div>
          )}
          <button onClick={roll} disabled={rolling}
            className={`mt-3 px-5 py-2 rounded-lg text-white font-semibold ${rolling ? 'bg-slate-400 cursor-wait' : 'bg-blue-600 hover:bg-blue-700'}`}
            data-testid="dice-roll">
            {rolling ? 'Rolling…' : '🎲 Roll Dice'}
          </button>
        </div>
        <div>
          {rolls.length > 0 && (
            <>
              <div className="flex flex-wrap gap-3 items-center" key={rollKey}>
                {rolls.map((v, i) => (
                  <div key={i}
                    className={rolling ? 'dice-rolling' : 'dice-tumble'}
                    style={{ animationDelay: `${i * 40}ms` }}>
                    {mode === 'conv' && sides === 6 ? pip(v) :
                      <div className="w-16 h-16 rounded-xl bg-white border-2 border-slate-900 flex items-center justify-center text-2xl font-bold">{v}</div>}
                  </div>
                ))}
              </div>
              <div className="mt-4 p-3 rounded-lg bg-blue-50 border border-blue-200">
                <div className="text-sm text-slate-600">Sum</div>
                <div className="text-3xl font-bold text-blue-700" data-testid="dice-sum">{total}</div>
              </div>
            </>
          )}
        </div>
      </div>
    </CalcShell>
  );
}
